import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_ctx.isActionsShowed)
    ? (_openBlock(), _createBlock(_component_button_dropdown, {
        key: 0,
        icon: "fas fa-ellipsis-h"
      }, {
        default: _withCtx(() => [
          (_ctx.isCanClose)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "primary small",
                loading: _ctx.state.is_loading,
                onClick: _ctx.closeProposal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Закрыть заявку ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isCanUpdate)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 1,
                class: "primary small",
                onClick: _ctx.emitUpdate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Редактировать заявку ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isCanDelete)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 2,
                class: "red text small",
                loading: _ctx.state.is_delete_loading,
                onClick: _ctx.deleteProposal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Удалить заявку ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}